<!-- Header -->
@if (slideAuthorFacade.currentSelectedSlideLayer$ | async; as layer) {
  <medsurf-slide-edit-header
    [icon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.LAYER"
    [label]="'enum.layer.' + (layer.window || FlatModels.LayerEntityModels.Window.null.toString()) | translate"
  [type]="'global.layer'"></medsurf-slide-edit-header>
}

<!-- Content -->
<div #edit_overlay_template_scroll_panel
  class="flex flex-1 overflow-auto justify-content-center">
  <!-- Layer Form -->
  @if (layerForm) {
    <medsurf-design-form-control-form
      [formGroup]="layerForm"
      class="w-full h-full ml-3 mr-3"
      (onSubmit)="onSubmit()">
      <!-- Window -->
      <medsurf-design-form-control-input-dropdown [control]="layerForm.controls.window"
        [label]="'global.designation'"
        [class]="'w-full align-self-start'"
        [placeholder]="'global.designation'"
        [options]="FlatModels.LayerEntityModels.WindowArray"
        [filter]="true"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-dropdown>
    </medsurf-design-form-control-form>
  }
</div>
